/*
函数：Date对象|时间字符串|时间戳，转换成指定格式的时间字符串
参数：
 - time为Date对象|时间字符串|时间戳
 - cFormat String。指定返回的字符串格式
*/
export function parseTime(time, cFormat = '{y}-{m}-{d} {h}:{i}:{s}') {
  if (time === undefined || time === null) {
    return null
  }
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) {
      time = parseInt(time) * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = cFormat.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

// 旋转完成
export function orientationChanged() {
  const timeout = 120;
  return new window.Promise(((resolve) => {
    const go = (i, height0) => {
      if (window.innerHeight !== height0 || i >= timeout) {
        resolve();
      } else {
        window.requestAnimationFrame(() => go(i + 1, height0));
      }
    };
    go(0, window.innerHeight);
  }));
}

// 获取安卓版本号
export function getAndroidVersion() {
  let ua = navigator.userAgent.toLowerCase()
  let version = null
  if (ua.indexOf('android') >= 0) {
    version = (ua.match(/android [\d._]+/gi) + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.')
  }

  return version
}

export const TouchMixin = {
  data() {
    return {
      startX: null,
      startY: null,
      deltaX: null,
      deltaY: null,
      offsetX: null,
      offsetY: null
    };
  },

  methods: {
    touchStart(event) {
      this.resetTouchStatus();
      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;
    },

    touchMove(event) {
      const touch = event.touches[0];
      this.deltaX = touch.clientX - this.startX;
      this.deltaY = touch.clientY - this.startY;
      this.offsetX = Math.abs(this.deltaX);
      this.offsetY = Math.abs(this.deltaY);
    },

    resetTouchStatus() {
      this.deltaX = 0;
      this.deltaY = 0;
      this.offsetX = 0;
      this.offsetY = 0;
    },
  },
}
